import { render, staticRenderFns } from "./zzl-report-supplement-editor.vue?vue&type=template&id=580eae7a&scoped=true"
import script from "./zzl-report-supplement-editor.vue?vue&type=script&lang=js"
export * from "./zzl-report-supplement-editor.vue?vue&type=script&lang=js"
import style0 from "./zzl-report-supplement-editor.vue?vue&type=style&index=0&id=580eae7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580eae7a",
  null
  
)

export default component.exports